import { useTranslation } from '@mc/i18n'
import Image from 'components/LegacyImage'
import { STATIC_IMAGE_BASE } from 'libs/constants'

const DEFAULT_WIDTH = 137
const DEFAULT_HEIGHT = 12
const ASPECT_RATIO = DEFAULT_WIDTH / DEFAULT_HEIGHT

interface SeriesLogoProps {
  width: number
}

export const SeriesLogo = ({ width = DEFAULT_WIDTH }: SeriesLogoProps) => {
  const { t } = useTranslation('@mc/next')
  return (
    <div className='mc-my-4'>
      <Image
        alt={t('series.details.seriesLogo')}
        src={`${STATIC_IMAGE_BASE}/series-logo.svg`}
        width={width}
        height={width / ASPECT_RATIO}
      />
    </div>
  )
}
